import { truncAddr } from '@/lib/utils'
import { ADDRESSES } from '@/lib/contracts'

/// Resolve a gauge's farm address to a human label. A gauge is a HorizonEmissions farm keyed by the
/// thing it incentivises: a supply farm by the reserve's sToken, a borrow farm by the reserve asset,
/// a ALM vault farm by the vault address, a guardian-pool farm by its Safety Module. Checks reserves
/// first (from useProtocolState's `d`), then the vault list (from useVaultsList), then the address
/// book's per-reserve Safety Modules, then falls back to a truncated address.
export function gaugeLabel(vault, d, vaults) {
  const v = (vault || '').toLowerCase()
  if (!v) return 'gauge'
  for (const r of d?.reserves ?? []) {
    if ((r.sTokenAddress || '').toLowerCase() === v) return `${r.symbol} supply`
    if ((r.asset || '').toLowerCase() === v) return `${r.symbol} borrow`
  }
  for (const vt of vaults ?? []) {
    if ((vt.address || '').toLowerCase() === v) {
      return vt.name || `${vt.token0?.symbol ?? '…'}/${vt.token1?.symbol ?? '…'}`
    }
  }
  // Per-reserve guardian pool (Safety Module) farm: SAFETY_MODULE_<SYM> in the address book.
  for (const [k, val] of Object.entries(ADDRESSES)) {
    if (typeof val === 'string' && val.toLowerCase() === v && k.startsWith('SAFETY_MODULE_')) {
      return `${k.slice('SAFETY_MODULE_'.length)} guardian`
    }
  }
  return truncAddr(vault)
}
